module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/define-property.js
// module id = 91
// module chunks = 35783957827783 52252321336229